import { render, staticRenderFns } from "./GinopPlusz-1.2.3-21.vue?vue&type=template&id=11195eb1&scoped=true"
import script from "./GinopPlusz-1.2.3-21.vue?vue&type=script&lang=js"
export * from "./GinopPlusz-1.2.3-21.vue?vue&type=script&lang=js"
import style0 from "./GinopPlusz-1.2.3-21.vue?vue&type=style&index=0&id=11195eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11195eb1",
  null
  
)

export default component.exports